module.exports = __webpack_public_path__ + "assets/img/kncb-roland-ryan.e5d93e36.jpg";